module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "companyInfo"
  }, [_c('ul', {
    staticClass: "ui-list ui-company"
  }, [_c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "positionInfo"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.jobName))])]), _c('span', {
    staticClass: "pay"
  }, [_c('b', [_vm._v(_vm._s(_vm.salary))])])]), _vm._v(" "), _c('div', {
    staticClass: "edu"
  }, [_c('span', {
    staticClass: "yearImg"
  }), _c('span', {
    staticClass: "yearTxt"
  }, [_vm._v(_vm._s(_vm.jobLifeRequire))]), _vm._v(" "), _c('span', {
    staticClass: "eduImg"
  }), _c('span', {
    staticClass: "eduTxt"
  }, [_vm._v(_vm._s(_vm.educationRequire))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.treatment.length > 0),
      expression: "treatment.length > 0"
    }],
    staticClass: "temptation"
  }, [_c('span', [_vm._v("职位诱惑：" + _vm._s(_vm.treatment))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "companyHead"
  }, [_c('img', {
    attrs: {
      "src": _vm.enterpriseLogo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui-list-info company-info"
  }, [_c('div', {
    staticClass: "ui-company-title"
  }, [_c('span', {
    staticClass: "company-name"
  }, [_c('b', [_vm._v(_vm._s(_vm.enterpriseName))])])]), _vm._v(" "), _c('div', {
    staticClass: "company-type"
  }, [_c('span', [_vm._v(_vm._s(_vm.industry + '/' + _vm.level + '/' + _vm.count))])]), _vm._v(" "), _c('div', {
    staticClass: "company-address"
  }, [_c('span', [_vm._v(_vm._s(_vm.address))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "positionDetail"
  }, [_c('ul', {
    staticClass: "ui-list ui-detail"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "position-detail",
    domProps: {
      "innerHTML": _vm._s(_vm.jobDescrip)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-pos",
    on: {
      "click": _vm.goResume
    }
  }, [_c('span', [_vm._v("去填写简历")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', [_c('span', {
    staticClass: "positionImg"
  }), _c('span', {
    staticClass: "positionTxt"
  }, [_vm._v("职位描述")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e321382"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/position.vue
// module id = 235
// module chunks = 1